export enum TipoReajuste {
  IPCA = "IPCA",
  IGMPM = "IGP-M",
}

export enum ReajustePrevistoRealizado {
  "Previsto" = "P",
  "Realizado" = "R",
}

export interface Reajuste {
  readonly id?: number | null;
  readonly tipo?: string | null;
  readonly anoMesReferencia?: string | null;
  readonly percentual?: number | null;
  readonly previstoRealizado?: ReajustePrevistoRealizado | null;
  readonly idUsuario?: number | null;
}
